import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Componente para la secci�n de Datos Fiscales del Receptor
 * Soporta caracteres Unicode (acentos, �, s�mbolos especiales)
 */
const DatosFiscalesReceptor = ({
    cargandoForm,
    errors,
    clearError,

    // Props de datos fiscales del receptor
    register,
    selectedValues,
    setSelectedValues,
    handleRFCChange,
    setValue
}) => {
    const { token, setToken } = useToken();

    const [regimenesFiscales, setRegimenesFiscales] = useState([]);
    const [paises, setPaises] = useState([]);
    const [isForeignRFC, setIsForeignRFC] = useState(false);
    const { showErrorToast } = useToast();

    // Guard to prevent errors if register is not a function
    const registerField = (name) => register && typeof register === 'function' ? register(name) : {};

    /**
     * Obtiene los Regimenes Fiscales
     */
    const ObtenerRegimenesFiscales = async () => {
        const response = await fetch("/api/Facturas/ObtenerRegimenesFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setRegimenesFiscales(ObjDetalles.table2);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
     * Obtiene los paises del Cat Sat
     */
    const ObtenerCatPaises = async () => {
        const response = await fetch("/api/Facturas/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setPaises(ObjDetalles.table2);
            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    useEffect(() => {
        ObtenerRegimenesFiscales();
        ObtenerCatPaises();
    }, []);

    // Detectar si el RFC es extranjero
    useEffect(() => {
        const rfcValue = selectedValues.vRFC || '';
        setIsForeignRFC(rfcValue === 'XEXX010101000');
    }, [selectedValues.vRFC]);

    return (
        <>
            <h5 className="mt-3">Datos Fiscales del Receptor</h5>
            <Row>
                <Col xs={12} lg={12} className="mb-2">
                    {/* Raz�n Social */}
                    <Form.Label>Raz&oacute;n Social</Form.Label>
                    {
                        cargandoForm ?
                            <Skeleton />
                            : <Form.Control
                                size="sm"
                                autoComplete="off"
                                type="text"
                                defaultValue=""
                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                isInvalid={!!errors.vRazonSocial}
                                {...registerField('vRazonSocial')}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        clearError("vRazonSocial");
                                    }
                                }}
                            />
                    }
                    {errors.vRazonSocial && (
                        <Form.Text className="text-danger">{errors.vRazonSocial}</Form.Text>
                    )}
                </Col>
            </Row>

            <Row>
                <Col xs={6} lg={6}>
                    {/* RFC */}
                    <Form.Group className="mb-2">
                        <Form.Label>RFC</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    autoComplete="off"
                                    {...registerField("vRFC")}
                                    onChange={(e) => {
                                        handleRFCChange(e.target.value)
                                        if (e.target.value) {
                                            clearError("vRFC");
                                        }
                                    }}
                                    isInvalid={!!errors.vRFC}
                                />

                        }
                        {errors.vRFC && (
                            <Form.Text className="text-danger">{errors.vRFC}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
                <Col xs={6} lg={6}>
                    <Form.Group>
                        <Form.Label>C&oacute;digo Postal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="off"
                                    maxLength={5}
                                    {...registerField("vCP")}
                                    onChange={(e) => {
                                        let valor = e.target.value.replace(/\D/g, ""); // Elimina caracteres no num�ricos
                                        setValue("vCP", valor);
                                        if (valor) {
                                            clearError("vCP"); // Limpia errores si se ingresa algo
                                        }
                                    }}
                                    onBlur={(e) => {
                                        let valorIngresado = e.target.value.trim();
                                        if (valorIngresado === registerField("vCP").value) {
                                            return;
                                        }
                                        clearError("vCP");
                                    }}
                                    isInvalid={!!errors.vCP}
                                />
                        }
                        {errors.vCP && (
                            <Form.Text className="text-danger">{errors.vCP}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>


            <Row>
                <Col xs={12} md={12}>
                    {/* R�gimen Fiscal */}
                    <Form.Group className="mb-3">
                        <Form.Label>R&eacute;gimen Fiscal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select
                                    size="sm"
                                    isInvalid={!!errors.vCodigoRegimen}
                                    value={selectedValues.vCodigoRegimen || ""}
                                    onChange={(e) => {
                                        setSelectedValues((prev) => ({ ...prev, vCodigoRegimen: e.target.value }));
                                        if (e.target.value) {
                                            clearError("vCodigoRegimen");
                                        }
                                    }}
                                >
                                    <option value="">Selecciona un r&eacute;gimen</option>
                                    {regimenesFiscales.map((regimen, index) => (
                                        <option key={index} value={regimen.vCodigoRegimen}>
                                            {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoRegimen && (
                            <Form.Text className="text-danger">{errors.vCodigoRegimen}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Dropdown de Pa�ses (solo para RFC extranjero XEXX010101000) */}
            {isForeignRFC && (
                <Row>
                    <Col xs={12} md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>Pa&iacute;s <span className="text-danger">*</span></Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Select
                                        size="sm"
                                        isInvalid={!!errors.vPais}
                                        value={selectedValues.vPais || ""}
                                        onChange={(e) => {
                                            setSelectedValues((prev) => ({ ...prev, vPais: e.target.value }));
                                            if (e.target.value) {
                                                clearError("vPais");
                                            }
                                        }}
                                    >
                                        <option value="">Seleccione un Pa&iacute;s</option>
                                        {paises.map((pais, index) => (
                                            <option key={index} value={pais.cShortName}>
                                                {pais.cShortName} - {pais.vName}
                                            </option>
                                        ))}
                                    </Form.Select>
                            }
                            {errors.vPais && (
                                <Form.Text className="text-danger">{errors.vPais}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Email */}
            <Row>
                <Col xs={12} lg={12}>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="email"
                                    autoComplete="off"
                                    isInvalid={!!errors.vEmail}
                                    {...registerField("vEmail")}
                                />
                        }
                        {errors.vEmail && (
                            <Form.Text className="text-danger">{errors.vEmail}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

DatosFiscalesReceptor.propTypes = {
    // Props del receptor
    cargandoForm: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,

    // Props de datos fiscales del receptor
    register: PropTypes.func.isRequired,
    selectedValues: PropTypes.object.isRequired,
    setSelectedValues: PropTypes.func.isRequired,
    handleRFCChange: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired
};

export default DatosFiscalesReceptor;